import { defineMessages } from 'react-intl';

export default defineMessages({
    coverageTermTooltipLabel: {
        id: 'ml.quoteandbind.underlyingPolicyCoverageTerms.coverageTermTooltipLabel',
        defaultMessage: 'Which limit should I select?'
    },
    invalidOtherUMLimitFormat: {
        id: 'UnderlyingPolicyCoverageTermsComponent.invalidOtherUMLimitFormat',
        defaultMessage: 'Correct the Uninsured Motorist Limit. The limit format must be a combined limit (4-digit max, i.e. 1000) or split limits (4-digit max each, i.e. 1000/1000).'
    },
    invalidOtherLiabilityLimitFormat: {
        id: 'UnderlyingPolicyCoverageTermsComponent.invalidOtherLiabilityLimitFormat',
        defaultMessage: 'Correct the Liability Limit. Liability limit format must be a combined limit (4-digit max, i.e 1000) or split limits (4-digit max each, i.e. 1000/1000/1000).'
    },
    otherLimitGreaterThanZero: {
        id: 'UnderlyingPolicyCoverageTermsComponent.otherLimitGreaterThanZero',
        defaultMessage: 'Limit must be greater than 0.'
    }
 
});
